var React = require('react');

function IconServiceAnaly (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M21.6 20.823a5.275 5.275 0 0 0 .764-2.731 5.023 5.023 0 0 0-4.909-5.143 5.023 5.023 0 0 0-4.909 5.143 5.021 5.021 0 0 0 4.9 5.143 4.679 4.679 0 0 0 2.607-.8L23.451 26 25 24.377zm-4.145.126a2.86 2.86 0 1 1 2.727-2.857 2.8 2.8 0 0 1-2.731 2.857zm-.393-9.714a6.175 6.175 0 0 0-2.291.514l-.6-.949-4.145 7.063-3.288-4.023-3.96 6.64L1 19.143 6.455 10l3.273 4 4.364-7.429zm2.825.571a6.221 6.221 0 0 0-2.236-.56L23.233 2 25 3.349z","transform":"translate(-1 -2)"}));
}

IconServiceAnaly.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconServiceAnaly;

IconServiceAnaly.default = IconServiceAnaly;
